module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00577.67ab1602.jpg";